import React from 'react';

/**
 * Shares the mobile sidebar (temporary drawer) open state between the NavBar —
 * which owns the hamburger button — and HandleProfile, which owns the drawer.
 *
 * The hamburger used to live inside HandleProfile as a `position: fixed`
 * floating button at `top: 5rem; left: 2.5rem`, i.e. on top of whatever page
 * content happened to be there. Keeping the trigger in the navbar means it can
 * never overlap page content.
 */
const SidebarContext = React.createContext({
  mobileOpen: false,
  toggleSidebar: () => {},
  closeSidebar: () => {},
});

export function SidebarProvider({ children }) {
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const value = React.useMemo(
    () => ({
      mobileOpen,
      toggleSidebar: () => setMobileOpen((open) => !open),
      closeSidebar: () => setMobileOpen(false),
    }),
    [mobileOpen],
  );

  return <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>;
}

export function useSidebar() {
  return React.useContext(SidebarContext);
}

export default SidebarContext;
